import instance from "@/services/api";

export const residentialSettingsAPI = {
  async getResidentials() {
    return await instance()
      .get("/floor_map/common/residents/read/")
      .then((res) => res?.data);
  },
  async getEntrances(params) {
    return await instance()
      .get(`/floor_map/common/entrances/read/`, { params })
      .then((res) => res?.data);
  },
  async getResidentEntrances(resident_id) {
    return await instance()
      .get(`/floor_map/common/residents/${resident_id}/entrances/read/`)
      .then((res) => res?.data);
  },
  async getEntranceApartments(params = {}) {
    return await instance()
      .get("/floor_map/flat/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorSchema(params = {}) {
    return await instance()
      .get("/floor_map/floor_params/read/", { params })
      .then((res) => res?.data);
  },
  async getObjectInfo(params = {}) {
    return await instance()
      .get("/floor_map/floor_params/details/read/", { params })
      .then((res) => res?.data);
  },
  async getEntranceColors(params = {}) {
    return await instance()
      .get("/floor_map/flat/colours/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorLegendInfo(params = {}) {
    return await instance()
      .get("/floor_map/floor_params/param_types/read/", { params })
      .then((res) => res?.data);
  },
  async getEntranceLegendInfo(params = {}) {
    return await instance()
      .get("/floor_map/flat/param_types/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorParamTypes() {
    return await instance()
      .get("/floor_map/floor_params/param_types/all/read/")
      .then((res) => res?.data);
  },
  async getFloorParamFrames(params = {}) {
    return await instance()
      .get("/floor_map/common/frames/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorRooms(params = {}) {
    return await instance()
      .get("/floor_map/common/rooms/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorFlatRooms(params = {}) {
    return await instance()
      .get("/floor_map/floor_params/rooms/read/", { params })
      .then((res) => res?.data);
  },
  async updateFloorParam(body = {}, params = {}) {
    return await instance()
      .put("/floor_map/floor_params/update/", body, { params })
      .then((res) => res?.data);
  },
  async changeFloorGroup(body = {}, params = {}) {
    return await instance()
      .post("/floor_map/flat/grouping/", body, { params })
      .then((res) => res?.data);
  },
  async duplicateFloorGroup(body = {}, params = {}) {
    return await instance()
      .post("/floor_map/floor_params/duplicate/", body, { params })
      .then((res) => res?.data);
  },
  async duplicateFlatToFloors(body = {}, params = {}) {
    return await instance()
      .post("/floor_map/floor_params/replacement/", body, { params })
      .then((res) => res?.data);
  },
  async getFloorMapInfo(floor_map_id) {
    return await instance()
      .get(`/floor_map/${floor_map_id}/get_info/`)
      .then((res) => res?.data);
  },
  async addFloorMap(body = {}, params = {}) {
    return await instance()
      .post("/floor_map/add/", body, {
        params,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res?.data);
  },
  async editFloorMap(floor_map_id, body = {}, params = {}) {
    return await instance()
      .put(`/floor_map/${floor_map_id}/edit/`, body, {
        params,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res?.data);
  },
  async updateFloorMapLine(body, params) {
    return await instance()
      .put(`/floor_map/floor_params/details/update/`, body, { params })
      .then((res) => res?.data);
  },
  async deleteFloorMapLine(floor_param_id, params = {}) {
    return await instance()
      .delete(`/floor_map/floor_params/${floor_param_id}/delete/`, { params })
      .then((res) => res?.data);
  },
  async getBufferParams(params = {}) {
    return await instance()
      .get(`/floor_map/floor_params/buffer/read/`, { params })
      .then((res) => res?.data);
  },
  async blockParamType(body, params = {}) {
    return await instance()
      .post(`/floor_map/floor_params/param_types/block/`, body, { params })
      .then((res) => res?.data);
  },
  async getFloorMapErrors(floor_map_id) {
    return await instance()
      .get(`/floor_map/${floor_map_id}/check_error/`)
      .then((res) => res?.data);
  },
  async recalculateSmeta(body, params) {
    return await instance()
      .post("/floor_map/flat/smeta/recalculate/", body, { params })
      .then((res) => res?.data);
  },
  async recalculateFloorValues(floor_map_id, params) {
    return await instance()
      .post(`floor_map/${floor_map_id}/recalculate/`, { params })
      .then((res) => res?.data);
  },
  async getWorkSets(floor_map_id, params = {}) {
    return await instance()
      .get(`floor_map/${floor_map_id}/work_sets/`, { params })
      .then((res) => res?.data);
  },
  async getWorkSetMaterials(floor_map_id, work_set_id, params = {}) {
    return await instance()
      .get(`floor_map/${floor_map_id}/work_sets/${work_set_id}/materials/`, {
        params,
      })
      .then((res) => res?.data);
  },
  async getWorkSetFloors(floor_map_id, work_set_id, params = {}) {
    return await instance()
      .get(`floor_map/${floor_map_id}/work_sets/${work_set_id}/levels/`, {
        params,
      })
      .then((res) => res?.data);
  },
  async changeMaterial(floor_map_id, work_set_id, body = {}) {
    return await instance()
      .post(`floor_map/${floor_map_id}/work_sets/${work_set_id}/levels/`, body)
      .then((res) => res?.data);
  },
  async getPresetMaterialSets(params = {}) {
    return await instance()
      .get("/floor_map/common/preset/sets/read/", { params })
      .then((res) => res?.data);
  },
  async getPresetMaterials(params = {}) {
    return await instance()
      .get("/floor_map/common/preset/materials/read/", { params })
      .then((res) => res?.data);
  },
  async modifyFloorParamMaterials(floor_param_id, body = {}) {
    return await instance()
      .post(`/floor_map/floor_params/${floor_param_id}/materials/modify/`, body)
      .then((res) => res?.data);
  },
  async deleteFloorParamMaterial(floor_param_id, floor_param_material_id) {
    return await instance()
      .delete(
        `/floor_map/floor_params/${floor_param_id}/materials/${floor_param_material_id}/modify/`
      )
      .then((res) => res?.data);
  },
  async createFloorObject(body, params) {
    return await instance()
      .post(`/floor_map/flat/floor/create/`, body, { params })
      .then((res) => res?.data);
  },
};
